import { ref, onMounted } from 'vue';
import { database } from '../config/firebase';
import { ref as dbRef, get } from 'firebase/database';

export function useFirebaseConfig() {
    const googleApiKey = ref<string>('');
    const isLoading = ref<boolean>(true);
    const error = ref<string | null>(null);

    const loadGoogleApiKey = async (): Promise<void> => {
        try {
            isLoading.value = true;
            error.value = null;
            
            const configRef = dbRef(database, '/config/google_api_key');
            const snapshot = await get(configRef);
            
            if (snapshot.exists()) {
                googleApiKey.value = snapshot.val();
            } else {
                error.value = 'Google API key not found in Firebase';
            }
        } catch (err: any) {
            error.value = `Failed to load API key: ${err.message}`;
            console.error('Error loading Google API key from Firebase:', err);
        } finally {
            isLoading.value = false;
        }
    };

    // Auto-load on mount
    onMounted(() => {
        loadGoogleApiKey();
    });

    return {
        googleApiKey,
        isLoading,
        error,
        loadGoogleApiKey
    };
}
